import React from 'react';
import { Modal } from 'antd';
import SeoForm from './SeoForm'
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AddSeo({ businessToken }) {

    const general = useGeneralStore();
    const visible = general.view.seoModal;

    return (
        <Modal
            style={{
                top: 80
            }}
            className="custom-table"
            title="افزودن صفحه"
            visible={visible}
            destroyOnHidden={true}
            footer={false}
            onCancel={() => general.ToggleSeoModal()}>
            <SeoForm
                onSubmit={() => {
                    general.ToggleSeoModal()
                    general.NotifSuccess('اطلاعات سئو شریک تجاری با موفقیت ثبت شد')
                }}
                businessToken={businessToken}
            />
        </Modal>
    )
}
